import { errorStyles as styles } from './styles';

import * as React from 'react';

import { action, computed } from 'mobx';
import { inject, observer } from 'mobx-react';

import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';

import Button from 'bz-core-controls/controls/general/button';
import { Button as ClickButton } from 'click-controls';

import HideFrom from 'tm3-core/controls/hideFrom';
import ShowFor from 'tm3-core/controls/showFor';
import { IsProduct } from 'tm3-core/enums/product-enum';
import type TerminalPaymentDialogStore from './stores/terminal-payment-dialog-store';

interface IProps extends WithStyles<typeof styles> {
  terminalPaymentDialogStore?: TerminalPaymentDialogStore;
}

@inject('terminalPaymentDialogStore')
@observer
class TerminalPaymentError extends React.Component<IProps> {
  render() {
    const { classes, terminalPaymentDialogStore } = this.props;
    if (!this.show) {
      return null;
    }
    return (
      <div className={classes.textContainer}>
        <p className={classes.pairingErrorText}>
          {terminalPaymentDialogStore!.errorMessage || 'Error'}
        </p>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <HideFrom products={[IsProduct.Click]}>
            <Button flat={true} onClick={terminalPaymentDialogStore!.onCancel}>
              Cancel
            </Button>
            <Button onClick={terminalPaymentDialogStore!.onRequestPayment}>Retry</Button>
          </HideFrom>
          <ShowFor product={IsProduct.Click}>
            <ClickButton className="btn mr-2" onClick={terminalPaymentDialogStore!.onCancel}>
              Cancel
            </ClickButton>
            <ClickButton
              className="btn ml-2"
              onClick={terminalPaymentDialogStore!.onRequestPayment}
            >
              Retry
            </ClickButton>
          </ShowFor>
        </div>
      </div>
    );
  }

  @computed
  private get show(): boolean {
    const { terminalPaymentDialogStore } = this.props;
    return !!terminalPaymentDialogStore!.paymentError;
  }
}

export default withStyles(styles)(TerminalPaymentError);
